// extracted by css-extract-rspack-plugin
export default {"statusTag":"statusTag-TUtUG0"};